import "./ChemicalManufacturing.module.css";
import Header from "@/reusable_sections/Header";
import ChemicalHero from "./sections/ChemicalHero";
import ManufacturingApplications from "./sections/ManufacturingApplications";
import Technology from "./sections/Technology";
import Services from "./sections/Services";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ChemicalManufacturingPage() {
  return <div>
      <Header />
      <ChemicalHero />
      <ManufacturingApplications />
      <Technology />
      <Services />
      <CallToAction />
      <Footer />
    </div>;
}